import { createStore } from "solid-js/store";

const BASE = `${window.location.origin}/frames`;

type Frame = { url: string; v: number } | null;

const [frames, setFrames] = createStore<Record<string, Frame>>({});
const asked = new Set<string>();
let queue: string[] = [];
let timer: number | undefined;

async function flush() {
  timer = undefined;
  const ids = queue.splice(0, 100);
  if (!ids.length) return;
  try {
    const r = await fetch(`${BASE}/list?ids=${ids.join(",")}`);
    const data = r.ok ? await r.json() : {};
    for (const id of ids) setFrames(id, data[id] ?? null);
  } catch {
    for (const id of ids) asked.delete(id);
  }
  if (queue.length) timer = window.setTimeout(flush, 30);
}

/**
 * URL da moldura do usuario (reativa). Busca em lote na primeira leitura.
 */
export function frameOf(userId?: string): string | undefined {
  if (!userId) return undefined;
  if (!asked.has(userId)) {
    asked.add(userId);
    queue.push(userId);
    if (timer === undefined) timer = window.setTimeout(flush, 30);
  }
  return frames[userId]?.url;
}

export async function uploadFrame(token: string, userId: string, file: Blob) {
  const r = await fetch(`${BASE}/frame`, {
    method: "PUT",
    headers: { "x-session-token": token },
    body: file,
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error ?? "erro ao enviar a moldura");
  asked.add(userId);
  setFrames(userId, { url: data.url, v: data.v });
}

export async function removeFrame(token: string, userId: string) {
  const r = await fetch(`${BASE}/frame`, {
    method: "DELETE",
    headers: { "x-session-token": token },
  });
  if (!r.ok) throw new Error("erro ao remover a moldura");
  asked.add(userId);
  setFrames(userId, null);
}
